import React from 'react'
import AdminExpenseCategory from '../../components/AdminTabs/AdminExpenseCategory/AdminExpenseCategory'

const ExpenseCategory = () => {
  return (
    <div>
        <AdminExpenseCategory/>
    </div>
  )
}

export default ExpenseCategory
